/* ajax-add-to-cart.js — a SAJAT buy-boxok bekotese a kosar-drawerbe (2026-07-26).
 *
 * MIERT KELL: a `cart_type: drawer` beallitas ONMAGABAN NEM eleg. A Dawn AJAX-os kosarba-rakasa
 * a `<product-form>` custom elementen keresztul mukodik (assets/product-form.js). A mi egyedi
 * buy-boxaink (`snippets/ds-buybox.liquid` -> `ucpc__form`, `snippets/sticky-smart.liquid` ->
 * `stsm__cartform`) viszont csupasz `{% form 'product' %}`-ot hasznalnak, `<product-form>` nelkul
 * -> a bongeszo NATIV form-submitot csinal -> atnavigal a /cart oldalra, es a drawer meg sem nyilik.
 * (Kimerve 2026-07-26 Playwrighttal: kattintas utan url = /cart, cart-drawer.active = false.)
 *
 * MIT CSINAL: delegalt submit-elkapas MINDEN `/cart/add` form-on, ami nincs mar `<product-form>`-ban.
 * POST a /cart/add.js-re, a valaszban kert `cart-drawer` + `cart-icon-bubble` szekciokkal, majd
 * a Dawn sajat `CartDrawer.renderContents()`-e frissit es nyit. Igy NEM irjuk at a buy-boxokat,
 * es ha kesobb barmelyik atall `<product-form>`-ra, ez a shim automatikusan felreall.
 *
 * FAIL-SAFE: barmilyen hiba eseten NATIV submit fut le (a vasarlo sose ragadjon be egy nema hibaban).
 */
(function () {
  if (window.__dsAjaxAtcLoaded) return;
  window.__dsAjaxAtcLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds(d) {
    try {
      if (d && typeof d.getSectionsToRender === 'function') {
        return d.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { /* eshetoleges: fallback lent */ }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function showError(form, msg) {
    var box = form.querySelector('[data-ds-atc-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-ds-atc-error', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:8px 0 0;color:#B3261E;font-size:14px;line-height:1.4';
      form.appendChild(box);
    }
    box.textContent = msg;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || e.defaultPrevented) return;

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    // A Dawn sajat product-form-ja mar kezeli -> ne nyulj hozza (nincs dupla add).
    if (form.closest('product-form')) return;

    var d = drawerEl();
    if (!d || typeof d.renderContents !== 'function') return;   // nincs drawer -> maradjon a natur submit

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var origText = btn ? btn.textContent : '';
    var origWidth = btn ? btn.offsetWidth : 0;
    if (btn) {
      if (origWidth) btn.style.minWidth = origWidth + 'px';   // ne ugraljon a gomb
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = (window.dsT || {}).adding || 'Hozzáadás…';
    }
    var errBox = form.querySelector('[data-ds-atc-error]');
    if (errBox) errBox.textContent = '';

    var fd = new FormData(form);
    fd.append('sections', sectionIds(d).join(','));
    fd.append('sections_url', window.location.pathname);

    // Codex-audit F03 (2026-10-24): ha a tetel MAR bekerult, egy kesobbi (drawer-render) hiba nem
    // inditott masodik hozzaadast a nativ submittal. Sikeres add utan a kosar-oldalra viszunk.
    var added = false;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        // A /cart/add.js HIBANAL is 4xx + JSON-t ad `status`/`description` mezovel.
        if (res && res.status) {
          throw Object.assign(new Error(res.description || res.message || 'add failed'), { soft: true });
        }
        added = !!res;
        if (!res || !res.sections) {
          throw new Error('nincs sections a valaszban');
        }
        d.renderContents(res);   // ez frissit ES nyit (Dawn: renderContents -> open())
      })
      .catch(function (err) {
        if (err && err.soft) {
          // Uzleti hiba (pl. elfogyott) -> NE navigalj, mondd meg a vasarlonak.
          showError(form, err.message);
          return;
        }
        if (added) {
          // A kosar mar jo, csak a drawer nem rajzolodott ki -> a kosarat mutatjuk, nem adunk hozza ujra.
          console.error('[ds ajax-atc] drawer-hiba, kosar-oldal:', err);
          window.location.assign(ROOT + 'cart');
          return;
        }
        // Technikai hiba a hozzaadas ELOTT -> natur submit, hogy a vasarlo akkor is tudjon venni.
        // ponytail: halozati hibanal (a valasz elveszett) a szerver oldali add ismeretlen; ritka, a kosar ott jelzi.
        console.error('[ds ajax-atc] fallback natur submitra:', err);
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (origText) btn.textContent = origText;
          btn.style.minWidth = '';
        }
      });
  });
})();
